import {Component, OnInit} from '@angular/core';
import {ConnectionPointService} from '@app/api/nts';
import {FormApiService} from '@app/core/services/form-api.service';
import {FormControl, FormGroup} from "@angular/forms";

import { AlertService } from '@app/core/services/alert.service';

@Component({
  selector: 'app-close-connectionpoint',
  imports: [],
  templateUrl: './close-connectionpoint.component.html',
  styleUrl: './close-connectionpoint.component.css'
})
export class CloseConnectionpointComponent implements OnInit {

  /** ID **/
  public id?: string;
  public canBeRemoved: boolean = false;

  constructor(
    private readonly connectionPointService: ConnectionPointService,
    private readonly formApiService: FormApiService,
    private readonly alertService: AlertService,
  ) {
  }

  public ngOnInit(): void {
    this.connectionPointService.connectionPointValidateremoveGet(this.id).subscribe({
      next: (response) => {
        this.alertService.open('modal', 'info', 'connectionpoint.connectionCanBeRemoved');
        this.canBeRemoved = true;
      },
      error: (error) => {
        this.alertService.open('modal', 'warning', 'connectionpoint.connectionCannotBeRemoved');
        this.canBeRemoved = false;
      }
    });
  }

  public submit(): void {
    if (!this.canBeRemoved) return;

    const submitForm = new FormGroup({
      id: new FormControl(this.id)
    });

    this.formApiService.submit(
      submitForm,
      (data) => this.connectionPointService.connectionPointRemoveGet(data.id),
      {
        successMessage: 'connectionpoint.connectionpointRemoved',
        closeModal: true
      }
    );
  }
}
